<!-- Компонент основного заголовка страницы, может принимать в slot доп.контент -->
<template>
<header class="main-header">
	<h1 v-if="title" class="main-header__title" itemprop="headline">{{title}}</h1>
	<h2 v-if="subtitle" class="main-header__subtitle">{{subtitle}}</h2>
	<slot></slot>
</header>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
		},
		subtitle: {
			type: String,
		}
	},
}
</script>
<style lang="sass">
.main-header
	margin-bottom: 10px


.main-header__title
	font-size: 16px
	line-height: 18.2px
	color: #00599B
	font-family: 'Arial'
	font-weight: 700
	max-width: 1200px
	margin-bottom: 8px
.main-header__subtitle
	color: #00599B
	font-family: 'Arial'
	font-size: 12px
	font-weight: 300
	line-height: 17.9px




</style>